import * as React from 'react';
import moment from 'moment';
import { CompanyNodeEdge } from '../master/Company/constants';
import { Table, Spin, Button, Col, Divider, Row } from 'antd';
import { GraphqlQuery } from 'requestapijs';
import { ProductDetailsNodeConnection } from '../../schema';
import { Pagination } from 'sha-el-design';
import { downloadToFile } from '../helper';
import { BranchNodeEdge } from '../master/Branch/constants';
import { ITEM_WISE_GIFT_REPORT_CSV } from '../../config';
import { TSInput } from '../common/TSInput';
import { giftReportQuery } from './constants';

export class GiftReport extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      after: '',
      currentPage: 1,
    };
  }

  onChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string | number | boolean | null } },
  ) => {
    const nextState = { ...this.state };
    nextState[e.target.name] = e.target.value;
    this.setState(nextState);
  };

  columns = () => [
    {
      title: 'Gift No.',
      key: 'giftlNo',
      dataIndex: 'node.giftSet.edges[0].node.giftReceiptNo',
    },
    {
      title: 'Gift Date',
      key: 'giftDate',
      dataIndex: 'node.giftSet.edges[0].node.date',
    },
    {
      title: 'Gift by',
      key: 'giftBy',
      dataIndex: 'node.giftSet.edges[0].node',
      render: (data) =>
        data ? `${data?.orderByName} (${data?.orderByDesignation}) ` : '',
    },
    {
      title: 'Gift to',
      key: 'giftTo',
      dataIndex: 'node.giftSet.edges[0].node.customer.name',
    },
    {
      title: 'Product Name',
      key: 'product',
      dataIndex: 'node.product.name',
    },
    {
      title: 'Barcode 1',
      key: 'oldBarcode',
      dataIndex: 'node.product.oldBarcodeId',
    },
    {
      title: 'Barcode 2',
      key: 'newBarcode',
      dataIndex: 'node.product.newBarcodeId',
    },
    {
      title: 'Category',
      key: 'category',
      dataIndex: 'node.product.category.name',
    },
    {
      title: 'Division',
      key: 'division',
      dataIndex: 'node.product.division',
    },
    {
      title: 'Quantity',
      key: 'quantity',
      dataIndex: 'node.quantity',
    },
    {
      title: 'Rate',
      key: 'rate',
      dataIndex: 'node.rate',
    },
    {
      title: 'Gift Amount',
      key: 'amount',
      dataIndex: 'node.amount',
    },
  ];

  downloadCsv = (variables) => {
    let queryParams = '';
    for (const key in variables) {
      if (key in variables) {
        if (queryParams !== '') {
          queryParams += '&';
        }
        queryParams += key + '=' + encodeURIComponent(variables[key]);
      }
    }

    fetch(ITEM_WISE_GIFT_REPORT_CSV + '?' + queryParams)
      .then((value) => value.text())
      .then((v) =>
        downloadToFile(
          v,
          `item-wise-gift-report-${
            this.props.branch?.name
          }-${new Date().toISOString()}`,
          'ITEM WISE GIFT REPORT',
          this.props.company.name,
          this.props.branch?.name || '',
          moment().format('DD-MM-YYYY'),
          moment().format('DD-MM-YYYY'),
          '',
        ),
      );
  };

  afterStack = [''];

  onPageChange = (next: boolean, after: string, nextPage: boolean) => {
    if (next && nextPage) {
      this.setState({ after, currentPage: this.state.currentPage + 1 });
      this.afterStack.push(after);
    } else if (!next && this.afterStack.length > 1) {
      this.afterStack.pop();
      this.setState({
        after: this.afterStack[this.afterStack.length - 1],
        currentPage: this.state.currentPage - 1,
      });
    }
  };

  render() {
    const {
      company: { id: companyId },
    } = this.props;
    const branchId = this.props.branch?.id;
    const { after, currentPage } = this.state;
    const variables = { companyId, branchId, after };
    return (
      <div>
        <Row>
          <Col span={5}>
            <TSInput
              error=""
              addonBefore="Date"
              value={moment().format('YYYY-MM-DD')}
            />
          </Col>
          <Col span={7}>
            <TSInput
              error=""
              addonBefore="Location"
              value={this.props.branch?.name || 'Head Office'}
            />
          </Col>
        </Row>
        <Divider />
        <GraphqlQuery
          queryString={giftReportQuery}
          variables={variables}
          render={(
            response: { allProductDetails: ProductDetailsNodeConnection },
            error,
            loading,
          ) => {
            if (loading) return <Spin />;
            if (error) return <h3>Something Went Wrong!!</h3>;
            if (response) {
              return [
                <Table
                  dataSource={response.allProductDetails.edges}
                  columns={this.columns()}
                  key="Table"
                  pagination={false}
                  rowKey="node.id"
                  scroll={{ x: true }}
                />,
                <Pagination
                  key="Pagination"
                  totalCount={0}
                  cursorBasedPagination
                  currentPage={currentPage}
                  batchSize={20}
                  onChange={(_p, _ps, next) =>
                    this.onPageChange(
                      next,
                      response.allProductDetails.pageInfo.endCursor,
                      response.allProductDetails.pageInfo.hasNextPage,
                    )
                  }
                  style={{ float: 'right' }}
                />,
                <Button
                  style={{ float: 'right' }}
                  icon="download"
                  onClick={() => this.downloadCsv(variables)}
                  key="button"
                />,
              ];
            }
          }}
        />
      </div>
    );
  }
}

interface Props {
  company: CompanyNodeEdge;
  branch: BranchNodeEdge | null;
}

interface State {
  after: string;
  currentPage: number;
}
